import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "title"
};
const _hoisted_2 = {
  key: 0,
  style: {
    "font-weight": "700"
  }
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  class: "question"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  id: "questionBox"
};
const _hoisted_8 = ["onMousedown", "onTouchstart", "id"];
const _hoisted_9 = ["index"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_font = _resolveComponent("font");
  return _openBlock(), _createElementBlock("div", {
    class: "pwco",
    id: "pwco",
    onMousemove: _cache[2] || (_cache[2] = (...args) => $setup.moveQuestion && $setup.moveQuestion(...args)),
    onTouchmove: _cache[3] || (_cache[3] = (...args) => $setup.moveQuestion && $setup.moveQuestion(...args))
  }, [_createElementVNode("div", _hoisted_1, [$props.questionInfo.skill == 'S1' || $props.questionInfo.skill == 'S2' ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString($props.questionInfo.itemName), 1)) : _createCommentVNode("", true), _createElementVNode("p", {
    innerHTML: $props.questionInfo.itemInstruction
  }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "question-text",
    innerHTML: $setup.itemText
  }, null, 8, _hoisted_5)]), _withDirectives(_createElementVNode("span", {
    class: "pwco-move",
    id: "pwcoMove",
    style: _normalizeStyle({
      top: $setup.movingItem.top + 'px',
      left: $setup.movingItem.left + 'px'
    })
  }, _toDisplayString($setup.movingItem.text), 5), [[_vShow, !$setup.movingItem.isShow]]), $setup.isMountedOver ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(), _createBlock(_Teleport, {
    to: ".questionBoxT"
  }, [_createElementVNode("p", _hoisted_7, [_createElementVNode("i", {
    class: "questionPreview",
    style: _normalizeStyle({
      opacity: $setup.positionIndex == 0 && $setup.distance[0] && $setup.distance[0] <= 2500 ? 1 : 0
    })
  }, "|", 4), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.answerList, (answerItem, answerIndex) => {
    return _withDirectives((_openBlock(), _createBlock(_component_font, {
      key: 'answertext' + answerIndex
    }, {
      default: _withCtx(() => [answerItem.id != $setup.movingItem.id ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        onMousedown: e => $setup.setQuestionFromAnswer(e, answerItem, answerIndex),
        onTouchstart: e => $setup.setQuestionFromAnswer(e, answerItem, answerIndex),
        onTouchmove: _cache[0] || (_cache[0] = (...args) => $setup.moveQuestion && $setup.moveQuestion(...args)),
        onTouchend: _cache[1] || (_cache[1] = (...args) => $setup.overQuestion && $setup.overQuestion(...args)),
        id: answerItem.id
      }, _toDisplayString(answerItem.text), 41, _hoisted_8)) : _createCommentVNode("", true), _createElementVNode("i", {
        class: "questionPreview",
        index: $setup.positionIndex,
        style: _normalizeStyle({
          opacity: $setup.positionIndex == answerIndex + 1 && $setup.distance[answerIndex + 1] && $setup.distance[answerIndex + 1] <= 2500 ? 1 : 0
        })
      }, "|", 12, _hoisted_9)]),
      _: 2
    }, 1024)), [[_vShow, answerItem.id != $setup.movingItem.id]]);
  }), 128))])]))])) : _createCommentVNode("", true)], 32);
}